export default "__VITE_ASSET__CcPAZ_rL__"